import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

const fallbackSessionStorage = new Map<string, string>()

const sessionStorageAdapter = {
  getItem(key: string) {
    if (typeof window === 'undefined') {
      return fallbackSessionStorage.get(key) ?? null
    }
    return window.sessionStorage.getItem(key)
  },
  setItem(key: string, value: string) {
    if (typeof window === 'undefined') {
      fallbackSessionStorage.set(key, value)
      return
    }
    window.sessionStorage.setItem(key, value)
  },
  removeItem(key: string) {
    if (typeof window === 'undefined') {
      fallbackSessionStorage.delete(key)
      return
    }
    window.sessionStorage.removeItem(key)
  },
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: sessionStorageAdapter,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
